class CustomTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.buttons = this.querySelectorAll('[data-tab-button]');
      this.contents = this.querySelectorAll('[data-tab-content]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const tabIndex = button.dataset.tabButton;

          this.buttons.forEach((item) => {
            item.classList.toggle(
              'active',
              item.dataset.tabButton === tabIndex
            );
          });

          this.contents.forEach((item) => {
            item.classList.toggle(
              'active',
              item.dataset.tabContent === tabIndex
            );
          });
        });
      });
    }
  }

  if (!customElements.get('custom-tabs')) {
    customElements.define('custom-tabs', CustomTabs);
  }